import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {CHART_WIDGET_TYPE_ID} from './chart-widget-type-id';
import {ChartWidgetComponent} from './chart-widget.component';
import {ChartWidgetImplementation} from './chart-widget.implementation';
import {ChartWidgetSettingsComponent} from './settings/chart-widget-settings.component';
import {ChartWidgetSettingsService} from './settings/chart-widget-settings.service';

export const CHART_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId: CHART_WIDGET_TYPE_ID,
    widgetLabel: 'components.widgets.chart-widget.widget_name',
    widgetImplementationType: ChartWidgetImplementation,
    widgetComponentType: ChartWidgetComponent,
    widgetSettingsServiceType: ChartWidgetSettingsService,
    settingsSchema: [
        {
            name: 'title',
            isShareable: false
        },
        {
            name: 'securityKey',
            isShareable: true,
            sharedName: 'securityKey'
        },
        {
            name: 'timeframe',
            isShareable: false
        },
        {
            name: 'isConfirmationEnabled',
            isShareable: false
        }
    ],
    hasGroupingSupport: true,
    widgetSettingsComponentType: ChartWidgetSettingsComponent
};
